import { render, staticRenderFns } from "./openTask.vue?vue&type=template&id=fb1526b2&scoped=true"
import script from "./openTask.vue?vue&type=script&lang=js"
export * from "./openTask.vue?vue&type=script&lang=js"
import style0 from "./openTask.vue?vue&type=style&index=0&id=fb1526b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1526b2",
  null
  
)

export default component.exports